import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import React, { createRef, useEffect, useRef } from "react";
import { sortEtablissements } from "../utils/sortEtablissements";
import clientComponent from "../config/clientComponents";

const Institution = ({
  data,
  selectedInstitution,
  setSelectedInstitution,
  client,
  filters,
  filtersState,
  setMapScreen,
  setScrollbarRef,
  lineRefs,
  filtersKeys,
}) => {
  let etablissements = [];
  //--- Needed to give the overlay scrollbar instance to InstitutionItem
  const scrollbarRef = useRef(null);

  //--- Dynamic import
  const InstitutionItem = clientComponent["InstitutionItem"];

  useEffect(() => {
    setScrollbarRef(scrollbarRef);
  }, [, data]);


  let sortedData = data
  if(process.env.REACT_APP_CLIENT === "new_mondelta") {
    const orderKeys = [
      ["mon-appart", "ma-villa"],
      ["mon-terrain"]
    ];
    sortedData = sortEtablissements(data, orderKeys, "type_slug");
  }

  etablissements = sortedData.map((etablissement, i) => {
    return (
      <InstitutionItem
        key={etablissement.id}
        filtersState={filtersState}
        etablissement={etablissement}
        selectedInstitution={selectedInstitution}
        setSelectedInstitution={setSelectedInstitution}
        filters={filters}
        setMapScreen={setMapScreen}
        scrollbarRef={scrollbarRef}
        allEtablissements={data}
        ref={lineRefs.current[i]}
        filtersKeys={filtersKeys}
      />
    );
  });

  return (
    <div className="institution">
      <div className="scroll-topFade" style={{ opacity: 1 }}></div>
      <OverlayScrollbarsComponent
        id="overlay-scrollbar"
        className="overlay-scrollbar os-theme-dark institution-wrapper"
        options={{
          overflowBehavior: {
            x: "hidden",
            y: "scroll",
          },
        }}
        ref={scrollbarRef}
      >
        {data.length > 0 ? etablissements : <div className="empty-data-container"><span>Aucun résultat</span></div>}
      </OverlayScrollbarsComponent>
      <div className="scroll-bottomFade" style={{ opacity: 1 }}></div>
    </div>
  );
};

export default Institution;
